<template>
  <div class="card">
    <div class="list list--nested">
      <div class="list__header py-2 pr-2 pl-6 flex justify-between items-baseline">
        <div class="text-gray-700">
          {{ $t('general') | capitalize }}
        </div>
      </div>
      <div class="list__body">
        <div class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700">
            {{ $t('description') | capitalize }}
          </span>
          <div v-if="campaign.description">
            {{ campaign.description }}
          </div>
          <div v-else>-</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignInfo',
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
};
</script>
